import React from "react";

const WORDS = [
  "Delivery",
  "Execution",
  "Outcomes",
  "Systems",
  "Institutions",
  "Performance",
  "Impact",
  "Implementation",
  "Capability",
  "Evidence",
  "Citizens",
  "Public Value",
];

export const Marquee = ({ dark = true }) => {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      className={`overflow-hidden border-y py-6 ${dark ? "border-white/10 bg-govx-black" : "border-govx-charcoal/10 bg-govx-paper"}`}
      data-testid="value-marquee"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={`font-display text-3xl font-light tracking-tight sm:text-5xl ${
                i % 3 === 1 ? "text-govx-green" : dark ? "text-govx-paper/85" : "text-govx-charcoal"
              }`}
            >
              {w}
            </span>
            <span className="text-govx-lime">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};
